export default __webpack_public_path__ + "static/DomaineText-Light-fff9f793092c066e8f5f53b160309b26.ttf";